import { AuthGateway } from "@/components/auth/AuthGateway";
import { useTenantPresentation } from "@/hooks/use-tenant-presentation";
import { authFrontDoorForHostname } from "@/lib/supabase/auth-front-door";

/** Tenant-owned Internal Google sign-in in the shared product language. */
export function SignInPage() {
  // Public branding via the centralized hook — logged out, so it only reads
  // GET /tenant (never /tenant/me). Best-effort: a no-tenant dev origin falls
  // back to the static tenant presentation.
  const { name, logoUrl, content } = useTenantPresentation();
  // Branding describes the public school surface, not its session issuer. The
  // release manifest is the sole authority for the auth transition, so Murtada
  // changes from its legacy password form only during the governed internal
  // cutover.
  const authTransition = authFrontDoorForHostname()?.transition ?? "legacy";

  return (
    <AuthGateway
      authTransition={authTransition}
      brandName={name}
      content={content.authGateway}
      logoUrl={logoUrl}
    />
  );
}
